import { useMutation } from "urql";
import { graphql } from "@acto/gql";
import { useCallback, useState } from "react";

const DeleteCustomTalkingPointMutation = graphql(`
  mutation DeleteCustomTalkingPoint($id: ID!) {
    deleteCustomTalkingPoint(id: $id) {
      id
      __typename
    }
  }
`);

export function useDeleteCustomTalkingPoint() {
  const [result, deleteCustomTalkingPointMutation] = useMutation(DeleteCustomTalkingPointMutation);
  const [error, setError] = useState<Error | null>(null);

  const deleteCustomTalkingPoint = useCallback(
    async (id: string) => {
      try {
        const response = await deleteCustomTalkingPointMutation({ id });
        if (response.error) {
          throw response.error;
        }
        return response.data?.deleteCustomTalkingPoint;
      } catch (err: unknown) {
        if (err instanceof Error) {
          setError(err);
          return null;
        } else {
          throw err;
        }
      }
    },
    [deleteCustomTalkingPointMutation],
  );

  return { deleteCustomTalkingPoint, result, error };
}
